import { render, staticRenderFns } from "./SaoMa.vue?vue&type=template&id=71671eee&scoped=true"
import script from "./SaoMa.vue?vue&type=script&lang=js"
export * from "./SaoMa.vue?vue&type=script&lang=js"
import style0 from "./SaoMa.vue?vue&type=style&index=0&id=71671eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71671eee",
  null
  
)

export default component.exports